import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-optional-billing-box',
  templateUrl: './optional-billing-box.component.html',
  styleUrls: ['./optional-billing-box.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class OptionalBillingBoxComponent {

  @Input() showBillingModule: boolean;

  @Output() setShowBillingModule: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  public setShowBillingModuleEvent(): void {
    this.setShowBillingModule.emit(!this.showBillingModule);
  }

}
